import React, {useState} from 'react';
import { Link , useLocation, useHistory } from 'react-router-dom';
import PageContainer from 'publish/layout/PageContainer';
import LayoutAside from "../../../layout/LayoutAside";
import UIDatePicker from "components/datepicker";
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import Breadcrumb from 'layouts/admin/Breadcrumb';
import CommonUtil from 'utils/CommonUtil';
import DateUtil from "utils/DateUtil";

function ContentsContainer() {
	const location = useLocation();
	const receivedData = (location.state as any)?.data;
	const history = useHistory();

	const [totalRowCnt,setTotalRowCnt] = useState(0);
	const [showRowCnt,setShowRowCnt] = useState(20); //기본 row count

	const [title, setTitle] = useState('');
	const [startDate,setStartDate] = useState(new Date(new Date().getFullYear()+'-01-01'));
	const [endDate,setEndDate] = useState(new Date(new Date().getFullYear()+'-12-31'));
	const [dateNum,setDateNum] = useState(0); //날짜 기본값
	const [searchOpt, setSearchOpt] = useState('0');         // 검색옵션

	//초기 데이터 설정
	let totalCnt:number = 0;
	let rowCnt:number =20;

	//====== 그리드 공통 부 START
	var ib = ib||{};
	// @ts-ignore
	ib = {
		//시트 초기화 구문
		'init':{
			"Cfg": {
				"SearchMode": 1,
				"PageLength": rowCnt,
				"InfoRowConfig": "0",
				"Alternate": "0",
				"Height": "auto",
				"HeaderMerge": 3,
				"MessageWidth": 300,
				"AutoRowHeight": true
			},
			"Def": {
				"Row": {
				}
			},
			//틀고정 좌측 컬럼 설정
			"LeftCols": [
				{"Header": "No","Name": "SEQ","Width": "90"}
			],
			"Cols": [
				{"Header": "No","Type": "Int", "Name": "SEQ","Align": "Center","RelWidth": 1,"CanEdit": "0"},
				{"Header": "등록일자","Type": "Text","Name": "REG_DATE","RelWidth": 1,"Align": "Center","CanEdit": "0"},
				{"Header": "수요조사 구분 번호","Type": "Text","Name": "DEMAND_NO","RelWidth": 1.5,"Align": "Center" ,"CanEdit": "0"},
				{"Header": "제목","Type": "Html","Name": "TITLE","RelWidth": 5,"Align": "left","CanEdit": "1"},
				{"Header": "모집기간","Type": "Text","Name": "DATE","RelWidth": 3,"Align": "Center","CanEdit": "0"},
				{"Header": "상태","Type": "Enum","Name": "STS_CD","RelWidth": 1,"Align": "Center","CanEdit": "0", "Enum": "|모집중|모집완료","EnumKeys": "|Y|N"},
				{"Header": "등록자","Type": "Text","Name": "REG_USERNM","RelWidth": 1,"Align": "Center","CanEdit": "0"},

			]
		},
		//시트 이벤트
		'event':{
			onRenderFirstFinish:function (evtParam) {

				//초기 데이터 로딩
				doSearch('init');


			},
			// 클릭 이벤트
			onAfterClick: function(evtParam:React.ChangeEvent<HTMLInputElement>) {
				// @ts-ignore
				//let NOTI_NO = evtParam.row.NOTI_NO;
				let row = sheet.getFocusedRow();

				// 다른 페이지로 이동하면서 데이터 전달
				let dataToSend = {DEMAND_NO : row["DEMAND_NO"].replaceAll('-','')};
				history.push({
					pathname: './adm1701',
					state: { data: dataToSend }
				});
			},
			onBeforeDataLoad:function (evtParam) {
				// 조회 후 로딩 전 발생 이벤트
				var d = evtParam.data;
				var _data;

				// 서버에서 가져온 데이터를 "데이터" 텝에 넣어준다.
				if (d.length > 20) { // 최대 20개 행만 텝에 넣어 주자(많아지면 화면이 엄청 느려질 수 있음)
					_data = JSON.stringify(d.slice(0, 20), null, 2);
					_data += _data.substring(0, _data.length - 1) + '...\n]';
				} else {
					_data = JSON.stringify(d, null, 2);
				}

			},
			//데이터 로딩 후 이벤트 처리
			onDataLoad:function (evtParam) {
			},
			onAfterGotoPage:function (evtParam) {

				var sheet = evtParam.sheet;
				var page = sheet.getPageIndex(sheet.getFocusedPage()) + 1;
				//@ts-ignore
				if (currentPage != -1 && currentPage != page) {
					makePageIndex(page);
				}

			}
		},
		//시트객체 생성
		'create':function () {
			let options = this.init;

			//@ts-ignore
			options.Events = this.event;
			//@ts-ignore
			IBSheet.create({
				id: 'sheet', // 생성할 시트의 id
				el: 'sheetDiv', // 시트를 생성할 Dom 객체 및 id
				options: options, // 생성될 시트의 속성
				data: this.data // 생성될 시트의 정적데이터
			});
			// global 변수 선언
			//@ts-ignore
			window.currentPage = -1;
		},
		//엑셀 다운로드
		'exportData':function () {
			let today:string = DateUtil.currentDateFormat("YYYYMMDD");
			//@ts-ignore
			IBSheet.sheet.down2Excel({fileName: "수요조사"+today+".xlsx", SheetDesign:1, downCols: "Visible"});
		},
		//조회 데이터
		'data':[]
	}

	//====== 그리드 공통 부  END


	const handleSelect = (e) => {
		if(e.target.name === 'notiDivCd'){
			if(e.target.value === '0'){
				// setNotiDivCd('');
			} else {
				// setNotiDivCd(e.target.value);
			}
		} else if(e.target.name === 'showRowCnt'){
			setShowRowCnt(e.target.value);

			rowCnt = e.target.value;
			// @ts-ignore
			IBSheet.disposeAll(true);
			ib.init.Cfg.PageLength = e.target.value;
			ib.create();
		}
	};

	React.useEffect(() => {

		//ib시트 생성
		ib.create();

		return () => {
			// @ts-ignore
			IBSheet.disposeAll(true);
		}
	},[])


	//====== 그리드 데이터 가지고 오기  START
	async function doSearch(sAction:string) {
		let param = {};
		let sDt = DateUtil.toDateFormat(startDate, "YYYY-MM-DD");
		let eDt = DateUtil.toDateFormat(endDate, "YYYY-MM-DD");

		if(sAction == 'search'){
			param = {
				ST_DATE : sDt,
				EN_DATE : eDt,
				TITLE : title,
			};
		} else {
			param = {
				ST_DATE : sDt,
				EN_DATE : eDt,
			};
		}


		const response:any = await CommonUtil.execute({
			url: 'adm_1700',
			data: param
		}).then((response: any) => {
			console.log(response);
			//전체ROW개수
			totalCnt = Object.keys(response.REC).length;
			setTotalRowCnt(Object.keys(response.REC).length);
			//전체데이터
			let result = response.REC;

			// @ts-ignore
			sheet.loadSearchData(result);  //data 로딩 처리
			// @ts-ignore
			sheet.InfoRow.Visible = 0; // 페이지네비게이션 표시 안함
			// @ts-ignore
			makePageIndex(sheet.getPageIndex( sheet.getFocusedPage()) + 1); // 페이지 초기화
		}).catch((error) => {
			CommonUtil.showAxiosError(error);
			return;
		});


	}

	//====== 그리드 데이터 가지고 오기  END

	//====== 그리드 페이징 처리
	// @ts-ignore
	const makePageIndex = function (tp:number) {
		try {
			if (tp == null) {
				//@ts-ignore
				currentPage = -1;
				return;
			}

			// @ts-ignore
			if (document.getElementById('pageNavi').firstChild) {
				// @ts-ignore
				document.getElementById('pageNavi').removeChild(document.getElementById('pageNavi').firstChild);
			}

			// @ts-ignore
			currentPage = tp;
			// @ts-ignore
			let sr = totalCnt // 전체 조회 건수
			// @ts-ignore
			let page = rowCnt; // 페이지당 레코드 수
			let thispage = tp; // 현재 페이지
			let pagecnt = 5; // 한번에 표시할 페이지 개수
			let lastpage = Math.ceil(sr / page); // 마지막 페이지 인덱스
			let li, tt, a;
			let ul = document.createElement('DIV');
			// @ts-ignore
			ul.style.textAlign = 'center';

			let k = 1;

			if (thispage !== 1) {
				let ul_sub = document.createElement('DIV');
				ul_sub.className ="group";
				li = document.createElement('Button');
				li.className = 'item first';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				tt = document.createTextNode('<<');
				addEventHandler(li, 'click', pageMove, 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);

				li = document.createElement('Button');
				li.className = 'item prev';
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, tp - 1);
				tt = document.createTextNode('<');
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub.appendChild(li)
				ul.appendChild(ul_sub);
			}

			sr = (Math.ceil(tp / pagecnt) * pagecnt) - (pagecnt - 1);
			let ul_sub2 = document.createElement('DIV');
			ul_sub2.className ="group";
			for (let i = sr; i < (sr + pagecnt); i++) {
				if (i <= lastpage) {
					li = document.createElement('Button');
					li.className ="item";
					a = document.createElement('a');
					a.style.cursor = 'pointer';
					tt = document.createTextNode(String(i));
					addEventHandler(li, 'click', pageMove, i);
					if (i === tp) {
						li.className ="item active";
					}
					a.appendChild(tt);
					li.appendChild(a);
					ul_sub2.appendChild(li);
					ul.appendChild(ul_sub2);
				}
			}

			if (thispage < lastpage) {
				let ul_sub3 = document.createElement('DIV');
				ul_sub3.className ="group";
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				li = document.createElement('Button');
				li.className = 'item next';
				tt = document.createTextNode('>');
				addEventHandler(li, 'click', pageMove, tp + 1);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);

				li = document.createElement('Button');
				li.className = 'item last';
				tt = document.createTextNode('>>');
				a = document.createElement('a');
				a.style.cursor = 'pointer';
				addEventHandler(li, 'click', pageMove, lastpage);
				a.appendChild(tt);
				li.appendChild(a);
				ul_sub3.appendChild(li);
				ul.appendChild(ul_sub3);
			}

			ul.className = 'pg';
			// @ts-ignore
			document.getElementById('pageNavi').appendChild(ul);
		} catch (ex) {
			// @ts-ignore
			alert(ex.message);
		}
	}

	//페이지 이동
	// @ts-ignore
	const pageMove = function (cPage:number) {
		// @ts-ignore
		sheet.goToPageByIndex(cPage);

	}

	//페이지 이동 이벤트 핸들러
	// @ts-ignore
	const addEventHandler = function (obj, evtName, func, param) {
		if (obj.addEventListener) { // all browsers except IE before version 9
			obj.addEventListener(evtName, function () { func(param); }, false);
		} else if (obj.attachEvent) { // IE before version 9
			obj.attachEvent('on' + evtName, function () { func(param); });
		}
	}

	async function SetDate(value){
		const newEndDate = new Date();
		setEndDate(newEndDate);  // 종료 날짜를 오늘로 설정
		const newStartDate = new Date(newEndDate);
		newStartDate.setDate(newEndDate.getDate() - value);
		setStartDate(newStartDate);  // 시작 날짜를 조정
	}

	//인풋 엔터체크
	const activeEnter = (e) => {
		if(e.key === "Enter") {
			doSearch('search');
		}
	}

	// 등록 페이지로 이동
	const onClickReg = function () {
		// 다른 페이지로 이동하면서 데이터 전달
		history.push({
			pathname: './adm1702',
		});

	};

	return (
		<PageContainer>
			<LayoutAside />
			<div className='fww-con'>
				<Breadcrumb gnbIdx={0} lnbD1Idx={6}  lnbD2Idx={1}/>
				<main className="fww-main">
					<h1 className="tx tx-hd2">수요조사 안내문 관리</h1>

					<div className="sf sf-1row sf-3col mb30"> {/* [M.20240522] */}
						<div className="inner">
							<div className="sf-item sf-m-1-3">
								<p className="sf-key">등록일자</p>
								<div className="sf-value">
									<div className="fund-datepicker">
										<div className="hz-item hz-root hz-gap5">
											<UIDatePicker className="hz-item" value={startDate} valueChanged={(value) => setStartDate(value)}/>
											<span className="hz-item">~</span>
											<UIDatePicker className="hz-item" value={endDate} valueChanged={(value) => setEndDate(value)}/>
										</div>
										<div className="hz-item hz-root hz-gap5">
											<Button color={dateNum == 1 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(90); setDateNum(1); }}>이전 3개월</Button>
											<Button color={dateNum == 2 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(180); setDateNum(2); }}>이전 6개월</Button>
											<Button color={dateNum == 3 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(365); setDateNum(3); }}>이전 12개월</Button>
											<Button color={dateNum == 4 ? 'pri' : 'pri-o2'} size="md" onClick={() => { SetDate(730); setDateNum(4); }}>이전 24개월</Button>
										</div>
									</div>
								</div>
							</div>
							<div className="sf-item"> {/* [M.20240522] */}
								<p className="sf-key">제목</p>
								<div className="sf-value">
									<UIInput className={'tf tf-md w100p'} value={title} placeholder={'제목을 입력하세요'} valueChanged={(value) => setTitle(value)} onKeyEnter={(e) => activeEnter(e)}/>
								</div>
							</div>
						</div>
						<button className="bt" data-color="pri" data-size="md" type="button" onClick={() => doSearch('search')}>조회</button>
						{/* [M.20240522] */}
					</div>
					{/* [M.20240522]삭제 */}
					{/* <div className="hz-root hz-center mb30">
						<button className="bt" data-color="pri" data-size="md"  type="button">조회</button>
					</div> */}

					<div className="tb-top">
						<div>
							<p className="tx fc-black"></p>총 <em className="fw500">{totalRowCnt}</em>건
						</div>
						<div className="hz-root hz-gap5">
							<Button color="pri-o" size="sm" onClick={() => onClickReg()}>등록</Button>
							<div className="sl sl-sm w120">
								<select name="showRowCnt" id="showRowCnt" value={showRowCnt} onChange={(handleSelect)}>
									<option value="20">20개씩보기</option>
									<option value="50">50개씩보기</option>
									<option value="100">100개씩보기</option>
									<option value="200">200개씩보기</option>
									<option value="500">500개씩보기</option>
									<option value="1000">1000개씩보기</option>
								</select>
							</div>
						</div>
					</div>
					<div id='sheetDiv'>[D] IBSHEET 영역
						<button className="btn-file" type="button">첨부파일</button>
					</div>
					<div id="pageNavi" className="pg"></div>
				</main>
			</div>
		</PageContainer>
);
}
export default ContentsContainer;